import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPin, Phone, Mail } from 'lucide-react';
import styles from './Footer.module.css';
import logoCimbiosis from '../../assets/logo_cimbiosis.png';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const isEn = lang === 'en';

  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerDivider}></div>
      <div className="container">
        <div className={styles.footerContainer}>
          {/* Brand Info */}
          <div className={styles.brandCol}>
            <Link to={`/${lang}`} className={styles.footerLogo}>
              <img src={logoCimbiosis} alt="CINBIOSIS" />
            </Link>
            <p className={styles.brandDescription}>
              {t('footer.slogan')}
            </p>
          </div>

          {/* Quick Links */}
          <div className={styles.linksCol}>
            <h4 className={styles.footerTitle}>{t('footer.links')}</h4>
            <ul className={styles.footerLinks}>
              <li><Link to={`/${lang}/${isEn ? 'about' : 'nosotros'}`}>{t('navbar.about')}</Link></li>
              <li><Link to={`/${lang}/${isEn ? 'services' : 'servicios'}`}>{t('navbar.services')}</Link></li>
              <li><Link to={`/${lang}/${isEn ? 'projects' : 'proyectos'}`}>{t('navbar.projects')}</Link></li>
              <li><Link to={`/${lang}/${isEn ? 'contact' : 'contacto'}`}>{t('navbar.contact')}</Link></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className={styles.linksCol}>
            <h4 className={styles.footerTitle}>{t('footer.legal')}</h4>
            <ul className={styles.footerLinks}>
              <li><Link to={`/${lang}/${isEn ? 'privacy-policy' : 'politica-privacidad'}`}>{t('footer.privacy')}</Link></li>
              <li><Link to={`/${lang}/${isEn ? 'data-management' : 'tratamiento-datos'}`}>{t('footer.dataTreatment')}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className={styles.contactCol}>
            <h4 className={styles.footerTitle}>{t('footer.contact')}</h4>
            <ul className={styles.contactList}>
              {/*<li>
                <MapPin size={18} className={styles.contactIcon} />
                <span>{t('contactPage.addressText')}</span>
              </li>*/}
              <li>
                <Phone size={18} className={styles.contactIcon} />
                <a href="tel:+573001234567" className={styles.contactLink}>
                  {t('contactPage.phoneText')}
                </a>
              </li>
              <li>
                <Mail size={18} className={styles.contactIcon} />
                <a href="mailto:ventas@cinbiosis.com" className={styles.contactLink}>
                  {t('contactPage.emailText')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p>&copy; {currentYear} CINBIOSIS. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
